var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showSearchIconAppTicketSystem
        ? _c(
            "div",
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "margin-bottom": "-20px",
                    position: "relative",
                    "z-index": "1",
                  },
                  attrs: { type: "flex", gutter: 6 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Nhập tên phiếu bé ngoan",
                          clearable: "",
                        },
                        on: {
                          clear: function ($event) {
                            return _vm.searchHeaderMethodTicketSystem()
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchHeaderMethodTicketSystem()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("el-button", {
                                    attrs: { icon: "el-icon-search" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.searchHeaderMethodTicketSystem()
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2983641427
                        ),
                        model: {
                          value: _vm.getAllTicketAppSystemRequest.nameTicket,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.getAllTicketAppSystemRequest,
                              "nameTicket",
                              $$v
                            )
                          },
                          expression: "getAllTicketAppSystemRequest.nameTicket",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showSearchIconAppTicket
        ? _c(
            "div",
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "margin-bottom": "-20px",
                    position: "relative",
                    "z-index": "1",
                  },
                  attrs: { type: "flex", gutter: 6 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "button-left-class_search",
                          staticStyle: { width: "100%" },
                          attrs: { filterable: "", placeholder: "Chọn trường" },
                          on: {
                            change: function ($event) {
                              return _vm.searchHeaderMethodTicket()
                            },
                          },
                          model: {
                            value: _vm.getAllTicketAppRequest.idSchool,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.getAllTicketAppRequest,
                                "idSchool",
                                $$v
                              )
                            },
                            expression: "getAllTicketAppRequest.idSchool",
                          },
                        },
                        _vm._l(_vm.schoolList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              value: item.id,
                              label: `${item.id} - ${item.schoolName}`,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "Nhập tên phiếu bé ngoan",
                          clearable: "",
                        },
                        on: {
                          clear: function ($event) {
                            return _vm.searchHeaderMethodTicket()
                          },
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchHeaderMethodTicket()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _c("el-button", {
                                    attrs: { icon: "el-icon-search" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.searchHeaderMethodTicket()
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2205372086
                        ),
                        model: {
                          value: _vm.getAllTicketAppRequest.nameTicket,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.getAllTicketAppRequest,
                              "nameTicket",
                              $$v
                            )
                          },
                          expression: "getAllTicketAppRequest.nameTicket",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              staticClass: "wrap_tab",
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleClickTab },
              model: {
                value: _vm.activeTabName,
                callback: function ($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Hệ thống", name: "ticketAppSystem" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingDataTemplate,
                          expression: "loadingDataTemplate",
                        },
                      ],
                      ref: "multipleTable",
                      attrs: {
                        "empty-text": _vm.textTableTemplateSystemAppTab,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        data: _vm.ticketAppSystemList,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                      on: {
                        "selection-change":
                          _vm.handleSelectionChangeTemplateSystem,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          fixed: "",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "index",
                          label: "STT",
                          width: "80",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tên gói", "min-width": "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.id) +
                                      " - " +
                                      _vm._s(scope.row.nameTicket)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Mô tả gói", "min-width": "300" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.descriptionTicket)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Phiên bản",
                          "min-width": "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.version))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Tác vụ",
                          width: "300",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDetailTicketSystemAppDialog(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Chi tiết\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openUpdateTicketSystemAppDialog(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Sửa\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteTicketSystemAppMethod(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Xóa\n              ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "15px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9, offset: 11 } },
                        [
                          _c("el-pagination", {
                            staticStyle: {
                              "margin-right": "5.2rem",
                              "margin-left": "auto",
                            },
                            attrs: {
                              background: "",
                              "current-page": _vm.currentPagePaginationSystem,
                              "page-sizes": _vm.$pageListDefaultNew,
                              "page-size": _vm.sizeLimitSystem,
                              layout: "prev, pager,sizes, next",
                              total: _vm.sizeLimitSystem * _vm.totalPagesSystem,
                            },
                            on: {
                              "size-change": _vm.handleSizeChangeTemplateSystem,
                              "current-change":
                                _vm.handleCurrentChangeTemplateSytem,
                              "update:currentPage": function ($event) {
                                _vm.currentPagePaginationSystem = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.currentPagePaginationSystem = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "inline-flex",
                            "justify-content": "right",
                          },
                          attrs: { span: 2, offset: 2 },
                        },
                        [
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleActionTicketSystem } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "button-over",
                                  attrs: { type: "success" },
                                },
                                [
                                  _vm._v(
                                    "\n                Tác vụ\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-caret-bottom",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "addTicketSystem" } },
                                    [
                                      _vm._v(
                                        "Thêm phiếu bé ngoan\n                "
                                      ),
                                    ]
                                  ),
                                  !_vm.showSearchIconAppTicketSystem
                                    ? _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: "deleteManyTicketSystem",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Xoá phiếu bé ngoan\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Nhà trường", name: "ticketAppTab" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingDataTemplate,
                          expression: "loadingDataTemplate",
                        },
                      ],
                      ref: "multipleTable",
                      attrs: {
                        "empty-text": _vm.textTableTemplateAppTab,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255, 0)",
                        "highlight-current-row": "",
                        data: _vm.ticketAppList,
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        border: "",
                      },
                      on: {
                        "selection-change": _vm.handleSelectionChangeTemplate,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          align: "center",
                          fixed: "",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "",
                          type: "index",
                          label: "STT",
                          width: "80",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tên gói", "min-width": "200" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.id) +
                                      " - " +
                                      _vm._s(scope.row.nameTicket)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Mô tả gói", "min-width": "300" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.descriptionTicket)),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Nguồn",
                          width: "200",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatTypeTicket(scope.row.typeTicket)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Phiên bản",
                          "min-width": "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.row.version))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Mặc định hệ thống",
                          width: "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-checkbox", {
                                  on: {
                                    change: function ($event) {
                                      return _vm.setDefaultTicket(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.defaultTicket,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "defaultTicket", $$v)
                                    },
                                    expression: "scope.row.defaultTicket",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Tác vụ",
                          width: "300",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDetailTicketAppDialog(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Chi tiết\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled:
                                        scope.row.typeTicket === "system",
                                      size: "mini",
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openUpdateTicketAppDialog(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Sửa\n              ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteTicketAppMethod(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Xóa\n              ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "15px" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9, offset: 11 } },
                        [
                          _c("el-pagination", {
                            staticStyle: {
                              "margin-right": "5.2rem",
                              "margin-left": "auto",
                            },
                            attrs: {
                              background: "",
                              "current-page": _vm.currentPagePagination,
                              "page-sizes": _vm.$pageListDefaultNew,
                              "page-size": _vm.sizeLimit,
                              layout: "prev, pager,sizes, next",
                              total: _vm.sizeLimit * _vm.totalPages,
                            },
                            on: {
                              "size-change": _vm.handleSizeChangeTemplate,
                              "current-change": _vm.handleCurrentChangeTemplate,
                              "update:currentPage": function ($event) {
                                _vm.currentPagePagination = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.currentPagePagination = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "inline-flex",
                            "justify-content": "right",
                          },
                          attrs: { span: 2, offset: 2 },
                        },
                        [
                          _c(
                            "el-dropdown",
                            { on: { command: _vm.handleActionTicket } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "button-over",
                                  attrs: { type: "success" },
                                },
                                [
                                  _vm._v(
                                    "\n                Tác vụ\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-caret-bottom",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "addTicket" } },
                                    [
                                      _vm._v(
                                        "Thêm phiếu bé ngoan\n                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "deleteManyTicket" } },
                                    [
                                      _vm._v(
                                        "Xoá phiếu bé ngoan\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DetailTicketAppDialog", {
        ref: "DetailTemplateAppDialog",
        attrs: { isOpenDetailTicketAppDialog: _vm.showDetailTicketAppDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDetailTemplateAppDialog()
          },
        },
      }),
      _c("UpdateTicketAppDialog", {
        ref: "UpdateTicketAppDialog",
        attrs: { isOpenUpdateTicketAppDialog: _vm.showUpdateTicketAppDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeUpdateTicketAppDialog()
          },
        },
      }),
      _c("AddTicketAppDialog", {
        ref: "addTicketAppDialog",
        attrs: { isOpenAddTicketAppDialog: _vm.showAddTicketAppDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeAddTicketAppDialog()
          },
        },
      }),
      _c("AddTicketAppSystemDialog", {
        ref: "AddTicketAppSystemDialog",
        attrs: { isOpenAddTicketAppDialog: _vm.showAddTicketAppDialogSystem },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeAddTicketAppDialogSystem()
          },
        },
      }),
      _c("DetailTicketAppSystemDialog", {
        ref: "DetailTicketAppSystemDialog",
        attrs: {
          isOpenDetailTicketAppDialog: _vm.showDetailTicketSystemAppDialog,
        },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDetailTicketSysAppDialog()
          },
        },
      }),
      _c("UpdateTicketSystemAppDialog", {
        ref: "UpdateTicketSystemAppDialog",
        attrs: {
          isOpenUpdateTicketAppDialog: _vm.showUpdateTicketSystemAppDialog,
        },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeUpdateTicketSystemAppDialog()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }